import {ga} from './safe_ga'

export const gaTrack = (type, shareUrl, gaLabel) => {
  ga('send', 'social', { 'socialNetwork': type, 'socialAction': 'share', 'socialTarget': shareUrl })
  ga('send', 'event', 'social_sharing', type, gaLabel)
}

export const facebookAppId = () => {
  const facebookId = document.head.querySelector("[property='fb:app_id']")
  return (facebookId) ? facebookId.content : null
}
